<template>
  <section class="fg-will-change bg-white" aria-label="simple copy section">
    <div container>
      <div grid="row wrap">
        <div column="12" v-html="content"></div>
      </div>
    </div>
  </section>
</template>
<script>
  export default {
    props: {
      content: {
        type: String,
        default: '<p class="body-copy">Please visit Cloudcannon to generate content for this block.</p>'
      }
    }
  }
</script>
